import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import About from './pages/About';
import Hosting from './pages/Hosting';
import BlogList from './pages/BlogList';
import BlogEntry from './pages/BlogEntry';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminDashboard from './pages/admin/AdminDashboard';
import BlogListAdmin from './pages/admin/BlogListAdmin';
import BlogEditor from './pages/admin/BlogEditor';
import homestyles from  "./css/homestyles.module.css"
import NavigationBar from "./components/NavBar/NavigationBar";


const App = () => {
  return (
    
     <div className={homestyles['global-container']} >
          {/* <div>        
            
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/host">Hosting</Link>
            <Link to="/bloglist">Blog List</Link>          
      </div> */}
      <BrowserRouter>
        <NavigationBar/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='about' element={<About/>}/>
          <Route path='host' element={<Hosting/>}/>
          <Route path='bloglist' element={<BlogList/>}/>
          <Route path='blogentry/:slug' element={<BlogEntry/>}/>
          <Route path='blogentry' element={<BlogEntry/>}/>
          
          {/* Admin Routes - Protected by Cloudflare Access */}
          <Route 
            path='admin' 
            element={
              <ProtectedRoute>
                <AdminDashboard/>
              </ProtectedRoute>
            }
          />
          <Route 
            path='admin/blog' 
            element={
              <ProtectedRoute>
                <BlogListAdmin/>
              </ProtectedRoute>
            }
          />
          <Route 
            path='admin/blog/new' 
            element={
              <ProtectedRoute>
                <BlogEditor/>
              </ProtectedRoute>
            }
          />
          <Route 
            path='admin/blog/edit/:id' 
            element={
              <ProtectedRoute>
                <BlogEditor/>
              </ProtectedRoute>
            }
          />
          
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        </BrowserRouter>
     </div>
  );
}



export default App;
